import React, {createContext, useContext, useEffect, useState} from 'react';
import {Backdrop, CircularProgress} from '@mui/material';
import PropTypes from 'prop-types';

const LoadingContext = createContext({
  loading: false,
  addToLoading: () => {
  },
});

export function LoadingProvider({children}) {
  const [loadingPromiseCount, setLoadingPromiseCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(loadingPromiseCount > 0);
  }, [loadingPromiseCount]);

  const addToLoading = (promise) => {
    setLoadingPromiseCount(loadingPromiseCount + 1);
    return promise.finally(function() {
      setLoadingPromiseCount((currentLoadingPromiseCount) => currentLoadingPromiseCount - 1);
    });
  };

  const value = {loading, addToLoading};
  return (
    <LoadingContext.Provider value={value}>
      <Backdrop aria-busy="true" open={loading} sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
        <CircularProgress color="inherit"/>
      </Backdrop>
      {children}
    </LoadingContext.Provider>
  );
}

LoadingProvider.propTypes = {
  children: PropTypes.any,
};

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
}
